/**
 * AnalyticsService.js
 * Service for fetching trading analytics data from the strategy engine
 */

const STRATEGY_ENGINE_URL =
  process.env.REACT_APP_STRATEGY_ENGINE_URL ||
  "https://strategy-engine.houman-ghavamzadeh.workers.dev";

async function fetchApi(endpoint, params = {}) {
  const url = new URL(`${STRATEGY_ENGINE_URL}/api/analytics${endpoint}`);
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') url.searchParams.set(k, String(v));
  });
  
  const token = localStorage.getItem('auth_token');
  const headers = {
    'Content-Type': 'application/json',
  };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  
  const response = await fetch(url.toString(), { headers });
  
  if (!response.ok) throw new Error(`Analytics API error: ${response.status}`);
  const data = await response.json();
  if (!data.success) throw new Error(data.error || 'Unknown error');
  return data.data;
}

const AnalyticsService = {
  async getOverview(filters = {}) {
    return fetchApi('/overview', filters);
  },
  
  async getEquityCurve(filters = {}) {
    return fetchApi('/equity-curve', filters);
  },
  
  async getTimeBuckets(filters = {}) {
    return fetchApi('/time-buckets', filters);
  },
  
  async getHeatmaps(filters = {}) {
    return fetchApi('/heatmaps', filters);
  },
  
  async getBreakdowns(filters = {}) {
    return fetchApi('/breakdowns', filters);
  },
  
  async getTrades(filters = {}) {
    return fetchApi('/trades', filters);
  },
  
  async getInsights(filters = {}) {
    return fetchApi('/insights', filters);
  },
};

export default AnalyticsService;
